import sImg1 from '../images/services/buildlab_structured_cabling.jpg'
import sImg2 from '../images/services/buildlab_surveillance.jpg'
import sImg3 from '../images/services/buildlab_door_access.jpg'
import sImg4 from '../images/services/buildlab_fire_safety.jpg'
import sImg5 from '../images/services/buildlab_networks.jpg'

import bImg1 from '../images/services/buildlab_ai.jpg'
import bImg2 from '../images/services/buildlab_business_systems.jpg'
import bImg5 from '../images/services/buildlab_service_4.jpg'
import bImg6 from '../images/services/buildlab_marketing.jpg'
import bImg8 from '../images/services/buildlab_webdev_1.jpg'
import bImg9 from '../images/services/buildlab_cnc_machining.jpg'


const Services = [
    // ── Construction Projects ─────────────────────────────────────────
    {
        Id: '1',
        category: 'construction',
        sImg: sImg1,
        title: 'Low-Voltage & Structured Cabling',
        // seoTitle drives the single page's <title> and H1 only — card/menu labels keep `title`.
        seoTitle: 'Low-Voltage & Structured Cabling Design',
        slug: 'Low-Voltage-and-Structured-Cabling',
        thumb1: 'Div 27 & 28',
        thumb2: 'Cabling Design',
        col: 'col-lg-4',
        description: 'Complete low-voltage and structured cabling design, riser diagrams, MPOE/IDF coordination, and Division 27 specifications — purpose-built to eliminate redundancies and contain infrastructure costs.',
        metaDescription: 'Low-voltage and structured cabling design for multifamily and commercial projects — riser diagrams, MPOE/IDF coordination, and Division 27 specs. By BUILDLAB.',
    },
    {
        Id: '2',
        category: 'construction',
        sImg: sImg2,
        title: 'Surveillance Systems',
        seoTitle: 'Security Camera & Surveillance System Design',
        slug: 'Surveillance-Systems',
        thumb1: 'IP Cameras',
        thumb2: 'NVR / VMS',
        col: 'col-lg-4',
        description: 'IP surveillance design with optimized camera placement, NVR/VMS specs, and integration with access control — covering exteriors, common areas, and points of ingress/egress.',
        metaDescription: 'Security camera and surveillance system design for multifamily and commercial buildings — camera placement, NVR/VMS specs, and access control integration.',
    },
    {
        Id: '3',
        category: 'construction',
        sImg: sImg3,
        title: 'Door Access Systems',
        seoTitle: 'Door Access Control System Design',
        slug: 'Door-Access-Systems',
        thumb1: 'Mobile Entry',
        thumb2: 'Credentials',
        col: 'col-lg-4',
        description: 'Door access control design including video intercom (ButterflyMX), mullion and keypad readers, ingress/egress hardware coordination, and integration with building management systems.',
        metaDescription: 'Door access control system design — video intercoms, mullion and keypad readers, credential planning, and building-management integration. By BUILDLAB.',
    },
    {
        Id: '4',
        category: 'construction',
        sImg: sImg4,
        title: 'Fire & Life Safety',
        seoTitle: 'Fire & Life Safety — DAS/ERRCS & Area of Refuge Design',
        slug: 'Fire-and-Life-Safety',
        thumb1: 'DAS / ERCCS',
        thumb2: 'Area of Refuge',
        col: 'col-lg-4',
        description: 'Life safety design and coordination — DAS/ERCCS site surveys for permitting and Area of Refuge specifications — performed in-house at a fraction of the cost of separate specialty vendors.',
        metaDescription: 'DAS/ERRCS site surveys for permitting and Area of Refuge design — fire and life safety coordination performed in-house at a fraction of vendor cost.',
    },
    {
        Id: '5',
        category: 'construction',
        sImg: sImg5,
        title: 'Computer Networks & Common Areas',
        slug: 'Computer-Networks-and-Common-Areas',
        thumb1: 'WiFi / WAPs',
        thumb2: 'AV Buildout',
        col: 'col-lg-4',
        description: 'Building-wide WiFi infrastructure, common-area AV, computer labs, conference rooms, and leasing office technology — engineered for the way residents and operations teams actually use the space.',
        metaDescription: 'Building-wide WiFi, common-area AV, computer labs, and leasing-office technology — network design engineered for residents and operations teams.',
    },

    // ── Business IT ───────────────────────────────────────────────────
    {
        Id: '6',
        category: 'business',
        sImg: bImg1,
        title: 'AI Business Integration',
        slug: 'AI-Business-Integration',
        thumb1: 'Automation',
        thumb2: 'AI Training',
        col: 'col-lg-4',
        description: 'Integrate AI across your business lines to refine workflows, automate repetitive work, and surface insights — paired with hands-on training so your team actually adopts the tools and runs with them.',
        metaDescription: 'AI business integration — workflow audits, tool recommendations, automation, and hands-on team training so AI becomes a daily habit, not a demo.',
    },
    {
        Id: '7',
        category: 'business',
        sImg: bImg2,
        title: 'IT Services',
        slug: 'IT-Services',
        link: '/it-services',
        thumb1: 'Managed IT',
        thumb2: 'Cyber Security',
        col: 'col-lg-4',
        description: 'End-to-end IT under one roof — systems & network administration, cyber security, cloud & infrastructure, and fully managed services on a predictable monthly plan. One team accountable for keeping your business running and secure.',
    },
    {
        Id: '10',
        category: 'business',
        sImg: bImg5,
        title: 'Web Development',
        slug: 'Web-Development',
        thumb1: 'Websites',
        thumb2: 'Same Day Builds',
        col: 'col-lg-4',
        description: 'Modern, fast, conversion-focused websites and web apps — mobile-responsive, SEO-optimized, and analytics-ready from launch. Built on a stack your team can maintain, with turnarounds as fast as 24 hours through our Same Day Websites service.',
        metaDescription: 'Modern, fast, conversion-focused websites and web apps — mobile-responsive, SEO-optimized, analytics-ready, with 24-hour Same Day Website builds.',
    },
    {
        Id: '8',
        category: 'business',
        sImg: bImg9,
        title: 'Custom Software',
        slug: 'Custom-Software',
        link: '/custom-software',
        thumb1: 'Dashboards & Automation',
        thumb2: 'Configurators & CPQ',
        col: 'col-lg-4',
        description: 'When off-the-shelf software doesn’t fit, we build it — trading indicators, ROI calculators, dashboards, searchable data and mapping tools, AI automation and web apps, plus guided machine configurators, instant quoting, and ERP integration for manufacturers. Transparent, in-house engineering on a stack your team can actually maintain.',
    },
    {
        Id: '9',
        category: 'business',
        sImg: bImg8,
        title: 'Startup Package',
        slug: 'Startup-Package',
        link: '/startup-package',
        thumb1: 'Website & Logo',
        thumb2: 'Domain & Email',
        col: 'col-lg-4',
        description: 'Everything a new business needs to launch, in one bundle — a starter website, custom logo, domain, a year of hosting, business email, and social media setup. Get online fast and look established from day one.',
    },
    {
        Id: '11',
        category: 'business',
        sImg: bImg6,
        title: 'Marketing & SEO',
        slug: 'Marketing-and-SEO',
        thumb1: 'SEO',
        thumb2: 'Content',
        col: 'col-lg-4',
        description: 'Search, content strategy, and digital marketing programs that move the needle — measured against real business outcomes, not vanity metrics.',
    },
]

export default Services;
